
import React from 'react';
import { Toggle } from '@/components/ui/toggle';
import { HormoneType } from '@/utils/cycle-tracking';

interface ChartControlsProps {
  selectedHormones: HormoneType[];
  toggleHormone: (hormone: HormoneType) => void;
  showPhases: boolean;
  setShowPhases: (show: boolean) => void;
  isMobile?: boolean;
}

export const ChartControls: React.FC<ChartControlsProps> = ({
  selectedHormones,
  toggleHormone,
  isMobile = false
}) => {
  const hormonesList: {value: HormoneType, label: string, color: string}[] = [
    { value: 'estrogen', label: 'Estrogen', color: '#E27D60' },
    { value: 'progesterone', label: 'Progesterone', color: '#B8A99A' },
    { value: 'lh', label: 'LH', color: '#DAC9B9' },
    { value: 'fsh', label: 'FSH', color: '#91adaf' }
  ];
  
  return (
    <div className={`flex ${isMobile ? 'flex-wrap justify-center gap-2' : 'items-center space-x-4'}`}>
      <div className={`flex flex-wrap gap-1 ${isMobile ? 'justify-center' : ''}`}>
        {hormonesList.map((hormone) => (
          <Toggle
            key={hormone.value}
            pressed={selectedHormones.includes(hormone.value)}
            onPressedChange={() => toggleHormone(hormone.value)}
            size="sm"
            variant="outline"
            className={`h-7 px-2 py-1 text-xs ${isMobile ? 'flex-1' : ''}`}
            style={{
              borderColor: hormone.color,
              backgroundColor: selectedHormones.includes(hormone.value) ? `${hormone.color}20` : 'transparent',
              color: selectedHormones.includes(hormone.value) ? hormone.color : 'inherit'
            }}
          >
            {hormone.label}
          </Toggle>
        ))}
      </div>
    </div>
  );
};
